import React from 'react';
import { createRoot } from 'react-dom/client';
import './setup';
import './index.less';

import App from './routers/App';

createRoot(document.body.querySelector('#gm')!).render(<App />);
